import { render } from "./BuildingParts.vue?vue&type=template&id=a60139f4&scoped=true"
import script from "./BuildingParts.vue?vue&type=script&lang=js"
export * from "./BuildingParts.vue?vue&type=script&lang=js"

import "./BuildingParts.vue?vue&type=style&index=0&id=a60139f4&scoped=true&lang=css"
import "./BuildingParts.vue?vue&type=style&index=1&id=a60139f4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60139f4"]])

export default __exports__